// extracted by mini-css-extract-plugin
module.exports = {"olduser_modal":"OldUserModal_olduser_modal__pK0rY"};